module.exports = "/assets/data/c213841f6f4622f960eb6780acc5fe22-MK41.data.json";